import React, {useLayoutEffect} from "react";
import axios from "axios";
import {config} from "../Helpers/env";

const SystemAlertContext = React.createContext()
SystemAlertContext.displayName = 'CurrencyContext'


function SystemAlertProvider(props) {
    const [openSystem, setOpenSystem] = React.useState(false)


    React.useEffect(() => {
        const systemStatus = () => {
            axios.get(`${config.smsUrl}/cpatient/server_status`)
                .then((res) => {
                    const data = res.data;
                    if (data.is_active) {
                        setOpenSystem(false)
                    } else {
                        setOpenSystem(true)
                    }
                }).catch((err) => {
                setOpenSystem(true)
            });
        }
        systemStatus()
        let interval = null
        interval = setInterval(() => {
            systemStatus();
        }, 10000);

        return () => clearInterval(interval);
    }, []);

    return <SystemAlertContext.Provider value={{openSystem, setOpenSystem}}  {...props}/>
}

function useSystemAlert() {
    const context = React.useContext(SystemAlertContext)
    if (context === undefined) {
        throw new Error(`useSystemAlert must be used within a SystemAlertProvider`)
    }
    return context
}

export {SystemAlertProvider, useSystemAlert}

